<template>
  <div class="vip-service detail-card">
    <div class="detail-card-head">
      <div class="detail-card-head_title">尊享功能</div>
      <div
        class="detail-card-head_sub clickable"
        @click="toBiddogNetworkNotice"
      >
        全国优质商机，一站搞定，立刻前往
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="detail-card-body flex row-between">
      <!-- 已有功能 -->
      <div class="service-list" style="width: 100%">
        <div
          v-for="item in serviceList"
          :key="item.label"
          class="service-list-item clickable"
          @click="handleServiceClick(item)"
        >
          <img
            style="width: 40px; height: 40px"
            :src="
              require(`@/assets/images/personal-center/vip-home/icon-${item.value}.png`)
            "
            alt=""
          />
          <div class="service-list-item_label">{{ item.label }}</div>
        </div>
      </div>
      <!--<a-divider type="vertical" style="height: 80px" />-->
      <!-- 规划功能 -->
      <!--<div class="service-list" style="width: 30%">-->
      <!--  <div-->
      <!--    v-for="item in preServiceList"-->
      <!--    :key="item.label"-->
      <!--    class="service-list-item clickable"-->
      <!--    @click="handleServiceClick(item)"-->
      <!--  >-->
      <!--    <img-->
      <!--      style="width: 64px; height: 40px"-->
      <!--      :src="-->
      <!--        require(`@/assets/images/personal-center/vip-home/icon-${item.value}.png`)-->
      <!--      "-->
      <!--      alt=""-->
      <!--    />-->
      <!--    <div class="service-list-item_label">{{ item.label }}</div>-->
      <!--  </div>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
import { toBiddogPage } from '@/utils/utils'

export default {
  name: 'VipService',

  data() {
    return {
      // 标前狗功能列表
      serviceList: [
        {
          label: '全网商机',
          value: 'notice_search',
          serviceClick: () => {
            toBiddogPage('/network-notice')
          }
        },
        {
          label: '标讯订阅',
          value: 'subscription',
          serviceClick: () => {
            toBiddogPage('/subscription/list')
          }
        },
        {
          label: '竞争对手分析',
          value: 'competitor_analysis',
          serviceClick: () => {
            toBiddogPage('/competitor-analysis/list')
          }
        },
        {
          label: '采购单位分析',
          value: 'purchaser_analysis',
          serviceClick: () => {
            toBiddogPage('/purchaser-analysis/list')
          }
        },
        {
          label: '数据定制导出',
          value: 'custom_data',
          serviceClick: () => {
            toBiddogPage('/custom-data/filter')
          }
        },
        {
          label: '我的关注',
          value: 'follow',
          serviceClick: () => {
            toBiddogPage('/follow/project')
          }
        }
      ],
      // 标前狗灰度功能
      preServiceList: [
        {
          label: '投标决策分析',
          value: 'bid_analysis',
          serviceClick: () => {
            this.$antInfo({
              title: '投标决策分析',
              content:
                '投标决策辅助可提供类似项目动态、项目分析、热点中标企业、采购单位类型分布、类似项目评标专家、项目预算等多维度详尽数据，助您决策是否投标或合作投标、投标报价。'
            })
          }
        },
        {
          label: '招标文件分析',
          value: 'bid_file_analysis',
          serviceClick: () => {
            this.$antInfo({
              title: '招标文件分析',
              content:
                '招标文件分析为您快速提取招标文件的关键信息，如项目基本信息、投标人须知、评分项要求、合规项要求、废标项要求、关键项要求、注意事项等，AI只能提取和结构化展示，提升您解读招标文件的效率。'
            })
          }
        },
        {
          label: '标前狗文库',
          value: 'biddog_library',
          serviceClick: () => {
            this.$antInfo({
              title: '标前狗文库',
              content:
                '大数据整合全网招标、中标相关公告、附件，为您制作投标文件提供各类模板、项目或工程详细参数、造价、或品目品牌、详细参数、价格等提供一站式参考。'
            })
          }
        }
      ]
    }
  },

  methods: {
    /**
     * 前往标前狗全网商机搜索页
     */
    toBiddogNetworkNotice() {
      toBiddogPage('/network-notice')
    },

    /**
     * 处理功能点击事件
     */
    handleServiceClick(item) {
      if (item.serviceClick) item.serviceClick()
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-card {
  background-color: $white-color;
  border-radius: 4px;
  padding: 20px 24px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  .detail-card-head {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .detail-card-head_title {
      font-size: 16px;
      color: $text-color;
      @include text-bold;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        background: $member-fifth-color;
        margin-right: 6px;
        vertical-align: -12%;
      }
    }

    .detail-card-head_sub {
      font-size: 12px;
      color: $text-third-color;
      margin-left: 8px;

      &:hover {
        color: $primary-color;
      }
    }
  }
}

.service-list {
  display: flex;
  align-items: center;
  justify-content: space-around;

  .service-list-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .service-list-item_label {
      color: $text-color;
      font-size: 13px;
      margin-top: 10px;
    }
  }
}
</style>
